import React from 'react';
import CustomerSidebar from './CustomerSidebar';

/**
 * CustomerLayout Component
 * Main layout wrapper for customer portal pages
 */
const CustomerLayout = ({ children, title }) => {
  return (
    <div className="flex min-h-screen bg-neutral-50">
      {/* Sidebar */}
      <CustomerSidebar />

      {/* Main Content */}
      <div className="flex-1 ml-64">
        {/* Header */}
        <header className="bg-white shadow-sm border-b border-neutral-200 sticky top-0 z-40">
          <div className="px-8 py-6">
            <h1 className="text-2xl font-display font-bold text-neutral-900">
              {title || 'Customer Portal'}
            </h1>
          </div>
        </header>

        {/* Page Content */}
        <main className="p-8">
          {children}
        </main>
      </div>
    </div>
  );
};

export default CustomerLayout;
